import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumdharmasthlacabs() {



    const cardData = {




keyword: "Belgaum Dharmasthala Cabs",

headingDescription: "Belgaum Taxi Service provides comfortable, safe, and reliable Belgaum to Dharmasthala cab services for pilgrimage trips, family vacations, senior citizen travel, religious tours, and outstation journeys. Our Belgaum Dharmasthala cabs are designed to offer a convenient and peaceful travel experience for devotees visiting the famous Shri Manjunatha Temple and nearby spiritual attractions. Whether you require a one-way taxi, round-trip cab, or a customized pilgrimage package from Belgaum to Dharmasthala, we provide flexible travel solutions with professional drivers and well-maintained vehicles. Our fleet includes Swift Dzire, Sedan, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium cars suitable for individuals, families, and large groups.",

topPlaces: [
  {
    title: "Dharmasthala Manjunatha Temple",
    description: "Dharmasthala Manjunatha Temple is one of Karnataka's most famous pilgrimage destinations dedicated to Lord Shiva. The temple is known for its spiritual importance, charitable activities, and attracts thousands of devotees throughout the year."
  },
  {
    title: "Bahubali Statue Dharmasthala",
    description: "The Bahubali statue at Dharmasthala is a major Jain pilgrimage attraction known for its massive structure, peaceful surroundings, and religious significance."
  },
  {
    title: "Kukke Subramanya",
    description: "Kukke Subramanya is a famous pilgrimage destination near Dharmasthala dedicated to Lord Subramanya. It is known for its spiritual importance and attracts devotees from different states."
  },
  {
    title: "Mangalore",
    description: "Mangalore is a beautiful coastal city known for beaches, temples, Mangalore Airport, educational institutions, and business centers. It is a popular stop during Dharmasthala trips."
  },
  {
    title: "Udupi",
    description: "Udupi is a famous coastal destination known for Sri Krishna Temple, beaches, traditional cuisine, and cultural attractions. Many travelers combine Udupi with Dharmasthala pilgrimage tours."
  },
  {
    title: "Murudeshwar",
    description: "Murudeshwar is a popular coastal pilgrimage destination famous for the Shiva statue, Murudeshwar Temple, beaches, and Arabian Sea views."
  },
  {
    title: "Gokarna",
    description: "Gokarna is a scenic coastal town known for temples, Om Beach, Kudle Beach, and peaceful surroundings. It is a preferred destination for spiritual and leisure travelers."
  },
  {
    title: "Coorg",
    description: "Coorg is a beautiful hill station known for coffee plantations, waterfalls, forests, and pleasant weather. It is an ideal extension for travelers planning Karnataka holiday tours."
  },
  {
    title: "Bangalore",
    description: "Bangalore is Karnataka's major IT and business hub with corporate offices, technology parks, shopping destinations, and entertainment areas. Private cabs provide comfortable connectivity for long-distance travel."
  },
  {
    title: "Goa",
    description: "Goa is a famous holiday destination known for beaches, resorts, churches, and sightseeing attractions. Travelers can combine coastal Karnataka pilgrimage trips with Goa vacations."
  }
],




"services": [
  {
    "name": "Belgaum Dharmasthala Cabs",
    "description": "Book Belgaum Dharmasthala Cabs for a safe, comfortable, and reliable pilgrimage journey with professional chauffeurs and well-maintained AC vehicles. Travel conveniently from Belgaum to Dharmasthala Temple with Sedan, Ertiga, Innova Crysta, and SUV cab options available for families, groups, and individual travelers. Enjoy flexible one way, round trip, and customized cab packages with affordable fares and hassle-free booking."
  },
  {
    "name": "Belgaum to Dharmasthala Cab",
    "description": "Choose Belgaum to Dharmasthala Cab service for a smooth and comfortable journey with experienced drivers, clean vehicles, and affordable pricing. Our outstation cabs provide convenient travel solutions for Dharmasthala temple visits, family trips, weekend tours, and personal journeys with doorstep pickup and reliable service."
  },
  {
    "name": "Belgaum to Dharmasthala Taxi",
    "description": "Hire Belgaum to Dharmasthala Taxi for safe and convenient long-distance travel with professional chauffeurs and premium vehicles. Get comfortable seating, transparent fares, and flexible travel options for pilgrimage tours, family travel, and outstation transportation requirements."
  },
  {
    "name": "Belgaum to Dharmasthala Cab Service",
    "description": "Book Belgaum to Dharmasthala Cab Service for reliable transportation with experienced drivers and well-maintained cars. We offer Sedan, Ertiga, Innova Crysta, and premium cab options suitable for temple visits, corporate travel, family tours, and customized outstation trips."
  },
  {
    "name": "Belgaum to Dharmasthala Taxi Service",
    "description": "Get Belgaum to Dharmasthala Taxi Service with comfortable AC vehicles, professional chauffeurs, and affordable travel packages. Enjoy safe and timely transportation from Belgaum to Dharmasthala with flexible booking options for one way and return journeys."
  },
  {
    "name": "Belgaum to Dharmasthala One Way Cab",
    "description": "Book Belgaum to Dharmasthala One Way Cab for economical single-trip travel without return charges. Enjoy fixed pricing, doorstep pickup, comfortable vehicles, and experienced drivers for a convenient pilgrimage and outstation journey."
  },
  {
    "name": "Belgaum to Dharmasthala One Way Taxi",
    "description": "Choose Belgaum to Dharmasthala One Way Taxi for affordable point-to-point transportation. Our one way taxi services offer clean vehicles, professional drivers, flexible pickup locations, and comfortable travel for individuals and families."
  },
  {
    "name": "Belgaum to Dharmasthala Cab Booking",
    "description": "Complete Belgaum to Dharmasthala Cab Booking with easy reservations, quick confirmation, and multiple vehicle choices. Select from Sedan, Ertiga, Innova Crysta, and SUV cabs according to your passenger requirements and travel plans."
  },
  {
    "name": "Belgaum to Dharmasthala Taxi Booking",
    "description": "Reserve Belgaum to Dharmasthala Taxi Booking service for a hassle-free travel experience. Get reliable taxi availability, transparent pricing, comfortable cars, and skilled chauffeurs for temple tours, family trips, and outstation travel."
  },
  {
    "name": "Belgaum to Dharmasthala Car Rental",
    "description": "Hire Belgaum to Dharmasthala Car Rental service for private and comfortable travel with driver facilities. Choose from various vehicle categories for pilgrimage tours, family holidays, corporate journeys, and long-distance transportation."
  },
  {
    "name": "Belgaum to Dharmasthala Outstation Cab",
    "description": "Book Belgaum to Dharmasthala Outstation Cab for reliable interstate travel with experienced chauffeurs and premium vehicles. Our outstation taxi services include one way trips, round trips, family travel, and customized tour packages."
  },
  {
    "name": "Belgaum to Dharmasthala Innova Crysta Cab",
    "description": "Travel in comfort with Belgaum to Dharmasthala Innova Crysta Cab offering spacious interiors, premium seating, large luggage space, and experienced drivers. Ideal for families, groups, pilgrimage tours, and luxury outstation travel."
  },
  {
    "name": "Belgaum to Dharmasthala Ertiga Cab",
    "description": "Book Belgaum to Dharmasthala Ertiga Cab for comfortable 6 to 7 seater travel with affordable pricing. Perfect for family trips, small groups, temple visits, and long-distance journeys with professional driver assistance."
  },
  {
    "name": "Belgaum to Dharmasthala Sedan Cab",
    "description": "Choose Belgaum to Dharmasthala Sedan Cab for economical and comfortable travel with clean AC cars and professional chauffeurs. Sedan cabs are suitable for couples, small families, business trips, and personal journeys."
  },
  {
    "name": "Belgaum to Dharmasthala Round Trip Cab",
    "description": "Book Belgaum to Dharmasthala Round Trip Cab for flexible return travel packages with affordable fares and reliable drivers. Enjoy convenient pickup, waiting options, and comfortable transportation for temple visits and family tours."
  },
  {
    "name": "Belgaum to Dharmasthala Private Taxi",
    "description": "Hire Belgaum to Dharmasthala Private Taxi for personalized travel with dedicated vehicles and professional chauffeurs. Experience privacy, comfort, flexible timing, and safe transportation throughout your pilgrimage journey."
  },
  {
    "name": "Cheap Belgaum to Dharmasthala Cab",
    "description": "Find Cheap Belgaum to Dharmasthala Cab services offering budget-friendly fares with quality vehicles and reliable drivers. Enjoy affordable travel without compromising safety, comfort, and service standards."
  },
  {
    "name": "Best Belgaum Dharmasthala Cabs",
    "description": "Choose Best Belgaum Dharmasthala Cabs for premium travel solutions with experienced chauffeurs, well-maintained vehicles, and competitive pricing. Our cabs are perfect for pilgrimage tours, family vacations, and outstation travel."
  },
  {
    "name": "Online Belgaum to Dharmasthala Cab Booking",
    "description": "Book Online Belgaum to Dharmasthala Cab Booking service with quick reservations, instant confirmation, and flexible vehicle options. Enjoy convenient online booking for safe and comfortable travel."
  },
  {
    "name": "Belgaum to Dharmasthala Taxi Fare",
    "description": "Check Belgaum to Dharmasthala Taxi Fare and choose suitable cab packages based on your travel needs. Get transparent pricing for Sedan, Ertiga, Innova Crysta, and SUV vehicles with no hidden charges."
  },
  {
    "name": "Belgaum to Dharmasthala Car Hire",
    "description": "Hire Belgaum to Dharmasthala Car Hire service for comfortable chauffeur-driven vehicles. Perfect for temple visits, family tours, corporate travel, and customized outstation journeys with flexible rental options."
  },
  {
    "name": "Belgaum to Dharmasthala Cab Price",
    "description": "Get affordable Belgaum to Dharmasthala Cab Price with multiple vehicle choices and transparent fare options. Choose the right cab according to your budget, group size, and travel requirements."
  },
  {
    "name": "Belgaum to Dharmasthala Family Cab",
    "description": "Book Belgaum to Dharmasthala Family Cab for safe and comfortable travel with spacious vehicles and experienced drivers. Ideal for family pilgrimage tours, vacations, and weekend trips."
  },
  {
    "name": "Belgaum to Dharmasthala Temple Taxi",
    "description": "Reserve Belgaum to Dharmasthala Temple Taxi for a convenient pilgrimage journey to Dharmasthala Temple. Enjoy comfortable vehicles, professional drivers, and flexible travel packages for devotees and families."
  },
  {
    "name": "Belgaum to Dharmasthala Cab Fare",
    "description": "Get competitive Belgaum to Dharmasthala Cab Fare with reliable taxi services and different vehicle options. Enjoy affordable pricing, comfortable rides, and professional travel support."
  },
  {
    "name": "Belgaum to Dharmasthala Taxi Near Me",
    "description": "Find Belgaum to Dharmasthala Taxi Near Me for quick cab availability and convenient booking. Get doorstep pickup, clean vehicles, experienced drivers, and reliable outstation taxi service."
  },
  {
    "name": "Belgaum to Dharmasthala Outstation Taxi",
    "description": "Book Belgaum to Dharmasthala Outstation Taxi for safe and comfortable long-distance travel. Our taxis provide reliable transportation with flexible schedules, professional chauffeurs, and affordable packages."
  },
  {
    "name": "Belgaum to Dharmasthala Travel by Cab",
    "description": "Travel from Belgaum to Dharmasthala by Cab with comfortable seating, experienced drivers, and reliable service. Enjoy a smooth journey with premium vehicles suitable for families, groups, and pilgrimage travelers."
  }
],
"tableData": [
  ["Belgaum Dharmasthala Cabs", "Belgaum to Dharmasthala Cab"],
  ["Belgaum to Dharmasthala Taxi", "Belgaum to Dharmasthala Cab Service"],
  ["Belgaum to Dharmasthala Taxi Service", "Belgaum to Dharmasthala One Way Cab"],
  ["Belgaum to Dharmasthala One Way Taxi", "Belgaum to Dharmasthala Cab Booking"],
  ["Belgaum to Dharmasthala Taxi Booking", "Belgaum to Dharmasthala Car Rental"],
  ["Belgaum to Dharmasthala Outstation Cab", "Belgaum to Dharmasthala Innova Crysta Cab"],
  ["Belgaum to Dharmasthala Ertiga Cab", "Belgaum to Dharmasthala Sedan Cab"],
  ["Belgaum to Dharmasthala Round Trip Cab", "Belgaum to Dharmasthala Private Taxi"],
  ["Cheap Belgaum to Dharmasthala Cab", "Best Belgaum Dharmasthala Cabs"],
  ["Online Belgaum to Dharmasthala Cab Booking", "Belgaum to Dharmasthala Taxi Fare"],
  ["Belgaum to Dharmasthala Car Hire", "Belgaum to Dharmasthala Cab Price"],
  ["Belgaum to Dharmasthala Family Cab", "Belgaum to Dharmasthala Temple Taxi"],
  ["Belgaum to Dharmasthala Cab Fare", "Belgaum to Dharmasthala Taxi Near Me"],
  ["Belgaum to Dharmasthala Outstation Taxi", "Belgaum to Dharmasthala Travel by Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Comfortable Belgaum to Dharmasthala Cab Service",
    WhyChoosedescription: "Travel from Belgaum to Dharmasthala with a reliable private cab service offering comfortable vehicles, experienced drivers, and convenient travel options for a peaceful pilgrimage journey."
  },
  {
    WhyChooseheading: "Ideal Cab for Pilgrimage Trips",
    WhyChoosedescription: "Our Belgaum to Dharmasthala cabs are suitable for devotees, families, senior citizens, and groups visiting the famous Dharmasthala temple and nearby attractions."
  },
  {
    WhyChooseheading: "Private Taxi with Flexible Schedule",
    WhyChoosedescription: "Travel according to your preferred timing with a dedicated cab that gives you complete freedom over pickup, stops, and return planning."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options Available",
    WhyChoosedescription: "Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, and SUV cabs depending on passenger count, luggage, and comfort requirements."
  },
  {
    WhyChooseheading: "Experienced Drivers for Long Distance Travel",
    WhyChoosedescription: "Professional chauffeurs ensure a smooth journey with safe driving, route knowledge, and comfortable transportation throughout the trip."
  },
  {
    WhyChooseheading: "One Way & Round Trip Cabs",
    WhyChoosedescription: "Book a direct one-way taxi or select a return journey package based on your pilgrimage schedule and travel needs."
  },
  {
    WhyChooseheading: "Comfortable Travel for Families",
    WhyChoosedescription: "Spacious and well-maintained vehicles provide a relaxed experience for families travelling long distances with luggage and senior members."
  },
  {
    WhyChooseheading: "Easy Booking Assistance",
    WhyChoosedescription: "Get quick support for cab availability, vehicle selection, fare details, and trip planning for your Belgaum to Dharmasthala journey."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Dharmasthala Cabs?",
    answer: "Yes, we provide Belgaum to Dharmasthala cab services with comfortable vehicles and professional drivers for pilgrimage and personal travel."
  },
  {
    question: "Can I book a one-way cab from Belgaum to Dharmasthala?",
    answer: "Yes, one-way taxi services are available for passengers who require direct travel without a return journey."
  },
  {
    question: "Which vehicles are available for Belgaum to Dharmasthala travel?",
    answer: "You can select Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, and SUV cabs according to your group size and comfort needs."
  },
  {
    question: "Is this cab service suitable for temple visits?",
    answer: "Yes, the service is suitable for devotees, families, and groups visiting Dharmasthala temple and nearby spiritual destinations."
  },
  {
    question: "Can I book a return taxi from Dharmasthala to Belgaum?",
    answer: "Yes, return trip cabs are available with flexible timings according to your travel schedule."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup and drop facilities are available from Belgaum Airport, Railway Station, hotels, homes, and other preferred locations."
  },
  {
    question: "Can I customize my Dharmasthala trip with sightseeing?",
    answer: "Yes, additional sightseeing stops and customized travel plans can be arranged according to your requirements."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Applicable toll, parking, and additional travel charges depend on the selected package and are explained during booking."
  },
  {
    question: "Is Belgaum to Dharmasthala taxi available anytime?",
    answer: "Yes, taxi booking assistance is available for planned journeys and urgent travel requirements."
  },
  {
    question: "How can I book a Belgaum to Dharmasthala Cab?",
    answer: "Share your travel date, pickup location, passenger details, and preferred vehicle type to receive fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Prakash Kulkarni",
    feedback: "Our Dharmasthala pilgrimage trip from Belgaum was very comfortable. The driver was experienced, and the cab was clean and spacious.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Manjula Patil",
    feedback: "The journey was smooth and convenient for our family. The driver was helpful, and the overall taxi service was excellent.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum Dharmasthala Cabs",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-dharmasthala-cabs.webp",
  "description":
    "Book Belgaum Dharmasthala Cabs with Belgaum Taxi Service for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Belgaum to Dharmasthala with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for pilgrimage tours, family trips, temple visits, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-dharmasthala-cabs"
  }
};







    return (
        <div>

<Helmet>
  <title>Belgaum Dharmasthala Cabs | One Way Taxi Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum Dharmasthala Cabs with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Dharmasthala with Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable pilgrimage and outstation travel available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum Dharmasthala Cabs, Belgaum to Dharmasthala Cab, Belgaum to Dharmasthala Taxi, Belgaum to Dharmasthala Cab Service, Belgaum to Dharmasthala Taxi Service, Belgaum to Dharmasthala One Way Cab, Belgaum to Dharmasthala One Way Taxi, Belgaum to Dharmasthala Cab Booking, Belgaum to Dharmasthala Taxi Booking, Belgaum to Dharmasthala Car Rental"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>








            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/51.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumdharmasthlacabs ;